import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionkinekt() {
  return (
    <section className="solution-kinekt p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="order-2 order-md-1"
          >
            <StaticImage
              src="../../../images/case-studies/kinekt-new/solution-mob.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={812}
              height={868}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1 order-1 order-md-2"
          >
            <h2 className="head-h2-kinekt">
              The <span style={{ color: "#20A2BE" }}>Solution</span>
            </h2>
            <h5>AI-Powered Patient Engagement</h5>
            <p>
              To modernize Kinekt, <strong>TekRevol</strong> implemented a
              <strong> complete codebase overhaul</strong>, integrating
              cutting-edge AI and enhancing u user experience.
            </p>
            <div className="key-iplememt-list">
              <h5>Key Implementations</h5>
              <ul>
                <li>
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    Modernized Codebase
                  </span>
                  : Replaced outdated frameworks with <span>React</span>,{" "}
                  <span>React Native</span>, <span>Node.js</span> and{" "}
                  <span>MongoDB</span>.
                </li>
                <li>
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    AI-Powered Feedback Analysis
                  </span>
                  : Integrated{" "}
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    GPT-4
                  </span>{" "}
                  and{" "}
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    OpenAI
                  </span>{" "}
                  for natural language processing and sentiment analysis.
                </li>
                <li>
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    Enhanced UI/UX
                  </span>
                  :Redesigned the interface for intuitive navigation and
                  seamless experience across devices.
                </li>
                <li>
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    Automated Engagement
                  </span>
                  : Implemented AI-driven content creation and social media
                  automation,{" "}
                  <span style={{ color: "#314252", fontWeight: "700" }}>
                    streamlining patient interactions.
                  </span>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionkinekt;
